var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2WarehouseBis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 17v-6H17v6h4v19h-4v6h4v23h34V42h4v-6h-4V17h4zm-8 44H25V42h26v19zm0-25H25V17h26v19zM32 23a2 2 0 012-2h8a2 2 0 010 4h-8a2 2 0 01-2-2zm0 25a2 2 0 012-2h8a2 2 0 010 4h-8a2 2 0 01-2-2z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Warehouse_bis.9031d661.svg";
export { SvgE2WarehouseBis as ReactComponent };